import { useNumberFormat } from 'hooks/useNumberFormat';
import { TApplication } from 'lendingApi/applications.types';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';

type TProps = {
  application: TApplication;
};

export const ApprovalAmountCell = ({ application }: TProps) => {
  const { formatCurrency } = useNumberFormat();

  const allowedStatuses = [
    APPLICATION_STATUS.offered,
    APPLICATION_STATUS.conditional_offer,
    APPLICATION_STATUS.funded,
    APPLICATION_STATUS.expired,
    APPLICATION_STATUS.talking_to_customer,
    APPLICATION_STATUS.offer_rejected,
    APPLICATION_STATUS.offer_revoked,
  ];

  const approvalAmount =
    application.formal_offer_sets?.[0]?.formal_offers?.[0]?.max_amount;

  if (approvalAmount && allowedStatuses.includes(application.status)) {
    return <div>{formatCurrency(approvalAmount)}</div>;
  }

  return '-';
};
